import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useScheduleContext } from '../../../../context/ScheduleContext';
import { getGridTimelineData } from '../../../../helpers/schedule-helper';
import { isSameAs, unixDiff } from '../../../../helpers/times';
import cloneDeep from 'lodash.clonedeep';
import { GRID_VIEW_MINUTE_STEP } from '../../../../constants/page-settings/schedule';
import ScheduleGridTimeLine from '../../ScheduleComponents/ScheduleGrid/ScheduleGridTimeLine';
import ScheduleGridStreams from '../../ScheduleComponents/ScheduleGrid/ScheduleGridStreams';

import './style.scss';

const ScheduleGridView = ({
    currentUser,
    checkAuth,
    onRateEpisode,
}) => {
    const [timelineStep, setTimelineStep] = useState(GRID_VIEW_MINUTE_STEP);
    const {
        page,
        episodes,
        schedule,
        scheduleFilters,
        widgetSettings,
        scheduleHallsByDate,
        isWidget,
    } = useScheduleContext();

    const timelineData = useMemo(() => {
        return getGridTimelineData(
            !!scheduleFilters.date
                ? episodes.filter(({timeStart}) => isSameAs(timeStart, scheduleFilters.date))
                : episodes
            );
    }, [scheduleFilters, episodes]);

    const timelineOffset = useMemo(() => {
        if (!timelineData?.intervals?.[0] || !schedule?.[0]?.timeStart) {
            return 0;
        }

        return unixDiff(timelineData.intervals[0], schedule[0].timeStart) * timelineStep;
    }, [timelineData, schedule, timelineStep]);

    /**
     * Рассчет высоты последнего отрезка времени, для исключения пустого пространства в конце расписания.
     * Высчитывается из разницы конца времени таймлайна и времени окончания последнего эпизода,
     * уменоженное на высоту в пикселях промежутка в 1 минуту.
     * +10 - доп. оступ в 10px для компенcации возможных смещений эпизодов, погрешностях, и чтобы просто не прилипало к концу.
     */
    const endOffset = useMemo(() => {
        const lastEpisode = cloneDeep(schedule)?.sort((a, b) => a.timeStop - b.timeStop).slice(-1)?.[0] ?? null;
        if (!lastEpisode || !timelineData) {
            return 0;
        }

        const {timeStop: timelineEndTime} = timelineData;
        const {timeStop: episodeEndTime} = lastEpisode;

        return (unixDiff(timelineEndTime, episodeEndTime) * timelineStep) + 10;

    }, [schedule, timelineData, timelineStep]);

    useEffect(() => {
        setTimelineStep(parseInt(isWidget && !!widgetSettings?.gridCardHeightSize
            ? widgetSettings?.gridCardHeightSize
            : page.settings?.gridCardHeightSize ?? GRID_VIEW_MINUTE_STEP));
    }, [widgetSettings, page]);

    return (
        <div className="schedule-grid-view">
            <ScheduleGridTimeLine
                timelineData={timelineData}
                timelineOffset={timelineOffset}
                endOffset={endOffset}
                schedule={schedule}
                rowHeight={timelineStep * 60}
                settings={widgetSettings}
                isStreamsHidden={scheduleHallsByDate?.length <= 1}
            >
                <ScheduleGridStreams
                    streams={scheduleHallsByDate}
                    page={page}
                    episodes={schedule}
                    episodesOffset={timelineOffset}
                    timelineData={timelineData}
                    minuteStep={timelineStep}
                    widgetSettings={widgetSettings}
                    isStreamsHidden={scheduleHallsByDate?.length <= 1}
                    checkAuth={checkAuth}
                    onRateEpisode={onRateEpisode}
                    currentUser={currentUser}
                />
            </ScheduleGridTimeLine>
        </div>
    )
}

export default ScheduleGridView;
 